// extracted by mini-css-extract-plugin
export default {"label":"notFoundElement_label__CKZCL"};